var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtleImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_17746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 37.7102H68.58V41.1527H72V37.7102Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58 41.1528H65.1375V44.5728H68.58V41.1528Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1375 51.4355H61.7175V58.298H65.1375V51.4355Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1375 44.5728H61.7175V48.0153H65.1375V44.5728Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7175 48.0154H58.2975V51.4354H61.7175V48.0154Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7175 58.2981H51.435V61.7181H61.7175V58.2981Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.855 13.7253H51.435V17.1453H54.855V13.7253Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.435 54.8555H48.015V58.298H51.435V54.8555Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.015 51.4355H44.5725V54.8555H48.015V51.4355Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5725 48.0154H41.1525V51.4354H44.5725V48.0154Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.435 10.2827H34.29V13.7252H51.435V10.2827Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1525 51.4355H34.29V54.8555H41.1525V51.4355Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.29 48.0154H30.87V51.4354H34.29V48.0154Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87 51.4355H27.4275V54.8555H30.87V51.4355Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4275 54.8555H17.145V58.298H27.4275V54.8555Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0075 44.5728H20.5875V48.0153H24.0075V44.5728Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0075 34.29H20.5875V37.71H24.0075V34.29Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0075 27.4278V24.0078H27.4275V27.4278H30.87V34.2903H27.4275V37.7103H24.0075V41.1528H27.4275V44.5728H58.2975V41.1528H61.7175V37.7103H68.58V34.2903H65.1375V27.4278H61.7175V34.2903H58.2975V37.7103H54.855V34.2903H51.435V27.4278H54.855V24.0078H58.2975V27.4278H61.7175V20.5878H58.2975V17.1453H54.855V20.5878H51.435V24.0078H37.71V17.1453H34.29V13.7253H27.4275V17.1453H24.0075V20.5878H20.5875V27.4278H24.0075ZM34.29 37.7103H37.71V34.2903H48.015V37.7103H51.435V41.1528H34.29V37.7103Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 48.0154H17.145V51.4354H20.5875V48.0154Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 41.1528H17.145V44.5728H20.5875V41.1528Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 27.4282H17.145V34.2907H20.5875V27.4282Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5875 17.1455H17.145V20.588H20.5875V17.1455Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.145 51.4355H13.725V54.8555H17.145V51.4355Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.145 37.7102H13.725V41.1527H17.145V37.7102Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.725 34.29H10.2825V37.71H13.725V34.29Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.145 13.7253H6.86249V17.1453H17.145V13.7253Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2825 30.8701H3.44247V34.2901H10.2825V30.8701Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2825 24.0081H6.86249V27.4281H10.2825V24.0081Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86247 17.1455H3.44247V20.588H6.86247V17.1455Z",
    fill: "#282930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4425 20.5879H0V30.8704H3.4425V20.5879Z",
    fill: "#282930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_17746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleImage);
export default __webpack_public_path__ + "static/media/turtle-image.ee29f18a1e76e96028f477053833f21c.svg";
export { ForwardRef as ReactComponent };